import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const PlatformDetailSchema = z
  .object({
    platform: z.string(),
    partnerId: z.string(),
    platformLoginId: z.string(),
    roles: z.array(z.string()),
  })
  .describe('PlatformDetailSchema');

const GetPartnerMeProfileResponseDataSchema = z
  .object({
    name: z.string().nullable(),
    email: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    platforms: z.array(PlatformDetailSchema),
  })
  .describe('GetPartnerMeProfileResponseDataSchema');

const GetPartnerMeProfileResponseSchema = createApiResponseSchema(
  GetPartnerMeProfileResponseDataSchema,
);

export type GetPartnerMeProfileResponse = z.infer<typeof GetPartnerMeProfileResponseSchema>;

/** GET `/v1/partner/me/profile` — 파트너 프로필 조회 */
export const getPartnerMeProfile = withApiErrorCapture(
  lazyPipe(
    () =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetPartnerMeProfileResponse>(partnerApiPath.getMeProfile),
      ),
    validateApiResponse(GetPartnerMeProfileResponseSchema),
  ),
);
